import React from "react";
import { Switch, Route } from "react-router-dom";
import PersonaPage from "./components/createPage/PersonaPage";
import ListPage from "./components/listPage/ListPage";;

export const Path = {
  list: "/",
  create: "/create",
};

const Routes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path={Path.list} component={ListPage} />
      <Route exact path={Path.create} component={PersonaPage} />
    </Switch>
  );
};

export default Routes;